<template>
  <full-screen-modal class="connection-success" :buttons="buttons" :close-action="closeAction">
    <template v-slot:content>
      <div class="content">
        <lottie-player
          :src="JSON.stringify(require('@/assets/animations/yahavCredsConnectedSuccess.json'))"
          :autoplay="true"
          class="success-animation"/>
        <div id="title">{{ title }}</div>
        <div class="subtitle">{{ subtitle }}</div>
      </div>
    </template>
  </full-screen-modal>
</template>

<script>
import FullScreenModal from '@/base-components/FullScreenModal';

export default {
  name: 'ConnectionSuccess',
  components: {
    FullScreenModal,
  },
  props: {
    buttons: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
    },
    closeAction: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../scss/mixins';

  .connection-success {
    .content {
      color: $riseup_black;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .success {
        margin: 35px 0 40px;
        width: 160px;
        height: 160px;
      }

      .success-animation {
        margin: 65px auto 40px;
        width: 284px;
      }

      #title {
        font-size: 24px;
        line-height: 34px;
        font-weight: bold;
        font-family: SimplerPro;
        margin: 0 20px 15px;
      }

      .subtitle {
        font-family: SimplerPro;
        font-size: 16px;
      }
    }
  }
</style>
